// extracted by mini-css-extract-plugin
module.exports = {"SideWrapper":"styles_SideWrapper__1ybf1","SideWrapperInner":"styles_SideWrapperInner__2u3FH"};